
const getImageUrl = (path) => {
    if (!path) return null;
    // If it's already a full URL, return it
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }
    // If it's a data URL, return it
    if (path.startsWith('data:')) {
        return path;
    }
    // If it's a relative path, assume it's in the assets directory or public folder
    if (path.startsWith('/')) {
        return path;
    }
    // Default to assets folder for simple filenames
    return `/assets/images/${path}`;
};

const storageService = {
    getImageUrl
};

export default storageService;
